import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { DashboardIcon, FeedbackIcon, ResourceIcon, RoleManagementIcon, TeamsIcon } from "../../Icons";
import { FEEDBACK_VIEW_PERMISSION, GROUP_VIEW_PERMISSION, RESOURCE_ASSIGN_PERMISSION, RESOURCE_VIEW_PERMISSION, ROLES_VIEW_PERMISSION, USER_VIEW_PERMISSION } from "../../constant/permission";
import { checkAnyPermissionExist, checkPermissionExist, visibleAssignSectionList } from "../../utils/general";

const { Sidebar: UISidebar } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const SideBar = () => {
  const navigate = useNavigate();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const [mainMenuItems, setMainMenuItems] = useState([])
  const [menuItems, setMenuItems] = useState([])

  useEffect(() => {
    let _mainMenuItems = [
      {
        id: "39806cfc-242c-4899-a47b-cf7a5a7aa696",
        key: "dashboard",
        tooltip: "Applications",
        icon: <DashboardIcon />,
        visible: true,
        clickHandler: () => navigate(`/dashboard/${userData.user.uuid}`),
      },
    ]
    setMainMenuItems(_mainMenuItems.filter(e => e.visible === true));

    let _menuItems = [
      {
        id: "0559daaf-1f73-410a-9d44-a33e0e1ec20d",
        key: "team-management",
        tooltip: "Team Management",
        icon: <TeamsIcon />,
        visible: checkAnyPermissionExist([GROUP_VIEW_PERMISSION, USER_VIEW_PERMISSION, RESOURCE_VIEW_PERMISSION]),
        clickHandler: () => navigate(`/team-management/${userData.user.group.uuid}`),
      },
      {
        id: "5defcf7c-c008-4ea7-bfc5-4a771001e321",
        key: "resource-management",
        tooltip: "Resources Management",
        icon: <ResourceIcon />,
        visible: (((visibleAssignSectionList()).length > 0) && checkPermissionExist(RESOURCE_ASSIGN_PERMISSION)),
        // clickHandler: () => navigate(`/resource-management/${userData.user.group.uuid}`),
        clickHandler: () => navigate(`/resource-management`),
      },
      {
        id: "role-management",
        key: "roles",
        tooltip: "Role Management",
        icon: <RoleManagementIcon />,
        visible: checkPermissionExist(ROLES_VIEW_PERMISSION),
        clickHandler: () => navigate(`/roles`),
      },
      {
        id: "5defcf7c-c008-4ea7-bfc5-4a771001e322",
        key: "feedback",
        tooltip: "Feedback Management",
        icon: <FeedbackIcon />,
        visible: checkPermissionExist(FEEDBACK_VIEW_PERMISSION),
        clickHandler: () => navigate(`/feedback/${userData.user.group.uuid}`),
      }
    ];

    setMenuItems(_menuItems.filter(e => e.visible === true));

  }, [userData, configData]);


  return (
    <>
      <UISidebar mainMenuItems={mainMenuItems} menuItems={menuItems} />
    </>
  );
};

export default SideBar;
